var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrevexLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 52,
    viewBox: "0 0 49 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9704 35.3017H24.2734V51.9879L48.218 28.013C40.3034 27.0255 33.1409 26.5988 26.8142 26.5234L28.9704 35.2933V35.3017Z",
    fill: "#EAA03D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.3125 23.9877C5.0847 24.8496 12.3725 25.7953 21.8752 25.9626L21.9922 25.494C20.5547 24.6907 19.5768 23.1509 19.5768 21.3852C19.5768 18.7911 21.6829 16.6823 24.2738 16.6823V-0.00390625",
    fill: "#EAA03D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2756 51.996V35.3098H19.5786L21.7349 26.5566C12.5917 26.724 5.51275 27.6194 0.765625 28.4562L16.1771 34.1215L24.284 52.0043L24.2756 51.996Z",
    fill: "#D86748"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9704 21.3936C28.9704 23.1593 28.0009 24.699 26.5551 25.5024L26.6721 25.9877C33.1576 25.9208 40.5206 25.4773 48.6777 24.4396L32.372 17.8789L24.2734 -0.00390625V16.6907C26.8643 16.6907 28.9704 18.7994 28.9704 21.3936Z",
    fill: "#D86748"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.686 24.4396L24.2734 -0.00390625L32.3803 17.8789L48.686 24.4396Z",
    fill: "url(#paint0_linear_2060_40134)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.686 24.4396L24.2734 -0.00390625L32.3803 17.8789L48.686 24.4396Z",
    fill: "#E2833D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1693 34.1125L0.757812 28.4473L24.2762 51.9954L16.1693 34.1125Z",
    fill: "url(#paint1_linear_2060_40134)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1693 34.1125L0.757812 28.4473L24.2762 51.9954L16.1693 34.1125Z",
    fill: "#E2833D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2060_40134",
    x1: 33.0072,
    y1: 26.7576,
    x2: 36.6263,
    y2: 11.6216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2833D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EBA449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3BE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2060_40134",
    x1: 19.178,
    y1: 28.0456,
    x2: 12.3617,
    y2: 40.4735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2833D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EBA449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3BE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C857"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrevexLogo);
export default __webpack_public_path__ + "static/media/trevexLogo.1b277a20aa001ffd89288b39e965dce2.svg";
export { ForwardRef as ReactComponent };